import { AccordionItem } from '@dev-spendesk/grapes';

type Props = {
  value?: string;
  children: React.ReactNode;
  label: string;
  isOpen?: boolean;
};

export const SettingFieldPanel = ({
  value,
  children,
  label,
  isOpen,
}: Props) => {
  return (
    <AccordionItem
      open={isOpen}
      noAnimation
      renderHeader={() => (
        <div className="-ml-16 mr-16 flex w-full justify-between">
          <span className="title-m">{label}</span>
          {value && (
            <span className="text-content-secondary-bg-primary body-m">{value}</span>
          )}
        </div>
      )}
    >
      <div className="px-8 py-12">{children}</div>
    </AccordionItem>
  );
};
